<div
  class="ep-toast-container position-fixed bottom-0 end-0 p-3"
  aria-live="polite"
  aria-atomic="false">
  @for (toast of toastService.toasts(); track toast.id) {
    <ngb-toast
      [class]="toastClass(toast.type)"
      [autohide]="true"
      [delay]="toast.delay"
      (hidden)="toastService.remove(toast.id)">
      <div class="d-flex align-items-center gap-2">
        @if (toast.type === 'error') {
          <i class="bi bi-exclamation-circle-fill flex-shrink-0" aria-hidden="true"></i>
        } @else if (toast.type === 'success') {
          <i class="bi bi-check-circle-fill flex-shrink-0" aria-hidden="true"></i>
        } @else {
          <i class="bi bi-info-circle-fill flex-shrink-0" aria-hidden="true"></i>
        }
        <span>{{ toast.message }}</span>
      </div>
    </ngb-toast>
  }
</div>
